// extracted by mini-css-extract-plugin
export default {"header":"Results-module__header__xJiad","button":"Results-module__button__jN18X"};